var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings',{key:"user",attrs:{"settingTabs":_vm.userSettingTabs,"initialTab":_vm.initialTab}},[_vm._v("\n  "+_vm._s(this.$t('userSettings'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }